import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=2c064c02&scoped=true&"
import script from "./PlanDetails.vue?vue&type=script&lang=js&"
export * from "./PlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=2c064c02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c064c02",
  null
  
)

export default component.exports